import React from 'react';
import { Search, Timer, Target, TrendingUp } from 'lucide-react';

interface ConversionStat {
  icon: React.ComponentType<{ className?: string }>;
  text: string;
}

export function ConversionExplanation() {
  const stats: ConversionStat[] = [
    {
      icon: Search,
      text: 'Headlines are read 5 times more often than body text (according to advertising maestro David Ogilvy).'
    },
    {
      icon: Timer,
      text: 'You only have 6 seconds to "grab" the customer\'s attention with a clever headline, otherwise your site will remain unread.'
    },
    {
      icon: Target,
      text: 'You get another 40 seconds of a potential customer\'s attention if the headline is successful.'
    },
    {
      icon: TrendingUp,
      text: 'Change the conversion rate of a page by several times! You can only change one headline.'
    }
  ];

  return (
    <section className="py-16 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="bg-black text-white rounded-[48px] p-12 md:p-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-16 max-w-3xl leading-tight">
            If your site isn't converting, the reason is simple - <span className="text-[#B4FF8C]">a weak headline</span>
          </h2>
          
          <div className="grid md:grid-cols-2 gap-8 md:gap-12">
            {stats.map((stat, index) => {
              const IconComponent = stat.icon;
              return (
                <div key={index} className="flex items-start gap-4">
                  <div className="bg-white/10 p-3 rounded-full">
                    <IconComponent className="w-6 h-6 text-[#B4FF8C]" />
                  </div>
                  <p className="text-lg leading-relaxed">{stat.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}